import React from 'react';
import ErrorLabel from '../../../../form/components/ErrorLabel';
import useComponentVisible from '../../../../hooks/useComponentVisible';
import { getRegions } from '../../../../utils/parks/getters';
import { HolidayType } from '../../../../utils/parks/types';
import Dropdown from '../../../Dropdown';
import { ParkMultiSelect } from '../../../FilterComponents/ParkMultiSelect';
import { Palette, Variant } from '../../../Label';
import { getFilterSelectionString } from '../../helpers/getParkSelectionString';
import styles from './searchInput.module.scss';
const PROMOTED_PARKS = [
    'AH',
    'BR',
    'TP',
    'CT',
    'FG',
    'GS',
    'HA',
    'HO',
    'OR',
    'SE',
    'SN',
    'WD',
];
const SearchInput = ({ parks, onParkChange, className, onSubmit, error, showFeaturedPromo = false, }) => {
    // Hooks
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const parkSelectionString = getFilterSelectionString(parks);
    const ownershipRegions = getRegions(HolidayType.OWNERSHIP);
    // This is a temporary solution, so we can get an AB test out for showing a 'FREE SITE FEES' label on the park multi select
    const ownershipRegionsWithParkPromoLabels = showFeaturedPromo
        ? ownershipRegions.map((region) => (Object.assign(Object.assign({}, region), { parks: region.parks.map((park) => (Object.assign(Object.assign({}, park), (PROMOTED_PARKS.includes(park.code)
                ? {
                    label: {
                        text: 'FREE 2024 SITE FEES',
                        variant: Variant.SOLID,
                        palette: Palette.VIDID_ORANGE,
                    },
                }
                : undefined)))) })))
        : ownershipRegions;
    return (<div ref={ref} className={className}>
      <Dropdown className={styles.dropdown} selection={parkSelectionString} label='Which park?' open={isComponentVisible} setOpen={(isOpen) => setIsComponentVisible(isOpen)} doneLabel={'Search'} onSubmit={onSubmit} error={error}>
        <ParkMultiSelect regionsWithParks={ownershipRegionsWithParkPromoLabels} value={Array.from(parks)} onValueChange={onParkChange} isOrdered={false} showTown showSearch={isComponentVisible}/>
      </Dropdown>
      {error && <ErrorLabel error={'Please select one or more parks'}/>}
    </div>);
};
export default SearchInput;
